// Pixel-art HP heart, mirrored on the same 8×8 sprite contract as
// the currency icons (`public/heart.png`). Rendered through the
// shared `image-rendering: pixelated` rule so any integer scale-up
// stays crunchy. Use this anywhere the player's persisted HP shows
// up — header HP chip, Inn page, post-battle banners.

export function HeartIcon({ size = 12 }: { size?: number }) {
  return (
    <img
      src="/heart.png"
      alt="HP"
      width={size}
      height={size}
      style={{
        display: "inline-block",
        imageRendering: "pixelated",
        flexShrink: 0,
      }}
    />
  );
}
